import Styles from './styles.module.css';
import { IoImageOutline } from "react-icons/io5";

type PlaceholderProps = {
  /** 差し替える画面の名称。例: 求人票作成・学校送付画面 */
  label: string;
  /** 高さ（px）。省略時は 300px */
  height?: number;
};

/**
 * スクリーンショット差し替え用のプレースホルダー。
 * 実際の画面キャプチャを受け取り次第、img に差し替える。
 */
const Placeholder: React.FC<PlaceholderProps> = ({ label, height = 300 }) => {
  return (
    <div className={Styles.placeholder} style={{ minHeight: `${height}px` }}>
      <IoImageOutline className={Styles.placeholder_icon} />
      <span className={Styles.placeholder_label}>ここに「{label}」のスクリーンショットを貼る</span>
      <span className={Styles.placeholder_note}>※ 実際のサービス画面に差し替え予定</span>
    </div>
  );
};

export default Placeholder;
